<template>
  <div class="relative h-screen">
    <div class="absolute inset-0 h-full">
      <base-video
        autoplay
        class="absolute"
        :controls="false"
        fit="cover"
        loop
        src="https://assets.vans.com/video/upload/v1738710848/404-video-optimized-red.webm"
      />
    </div>
    <div v-style:p="{ sm: '3.5rem 1rem 0 1rem' }" class="relative container lg:pt-16">
      <div class="mt-4 ws-pre-wrap c-white lg:mt-6 lg:text-md space-y-6">
        <p class="text-xl italic">
          {{ $t.maintenance.ERR5xx.seoText }}
        </p>
        <h1 class="display-1 uppercase">
          {{ $t.maintenance.ERR5xx.title }}
        </h1>
        <p>
          {{ $t.maintenance.ERR5xx.message }}
        </p>
        <p class="fw-bold">
          {{ $t.maintenance.ERR5xx.nextStepsHeader }}
        </p>
        <span>
          {{ $t.maintenance.ERR5xx.nextStepsDetails }}
        </span>
      </div>
      <vf-button class="mt-8 b-white c-white <md:w-full" variant="transparent" @click="clearError({ redirect: '/' })">
        {{ $t.maintenance.ERR4xx.cta }}
      </vf-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
